import { ProductRateValues, ProductRateValuesHelper } from './productRateValues';

export interface ProductRate {
    base: ProductRateValues;
    b: ProductRateValues;
    c: ProductRateValues;
    d: ProductRateValues;
}

export class ProductRateHelper {

    static create(obj: Object = {}): ProductRate {
        const ini = {
            base: ProductRateValuesHelper.create(),
            b: ProductRateValuesHelper.create(),
            c: ProductRateValuesHelper.create(),
            d: ProductRateValuesHelper.create(),
        };

        return Object.assign(ini, obj);
    }

    static fromObject(obj: Object) {
        const rate = ProductRateHelper.create();
        rate.base = ProductRateValuesHelper.create(obj['base']);
        rate.b = ProductRateValuesHelper.create(obj['b']);
        rate.c = ProductRateValuesHelper.create(obj['c']);
        rate.d = ProductRateValuesHelper.create(obj['d']);
        return rate;
    }
}
